<template>
  <div>
  </div>
</template>

<script>
    export default {
        name: "ModifyNotification"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contents/main/notify/ModifyNotification.vue